
export default {
  name: 'FieldText',

  props: {
    value: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    error: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: 'auto',
    },
  },

  data() {
    return {
      internValue: null,
    };
  },

  watch: {
    value(value) {
      this.internValue = value;
    },
  },

  mounted() {
    this.internValue = this.value;
  },

  methods: {
    changed() {
      this.$emit('input', this.internValue);
    },

    enter() {
      this.$emit('enter');
    },
  },
};
